import axios, { AxiosRequestConfig } from 'axios';
import { GoogleConnection } from '../../types/social/GoogleConnection';
import { DataResponse, PagedResponse } from '../../types/api';

const URL = '/v2/google-connection';

export interface GoogleConnectionCreatePayload {
  userId?: number;
  googleUser: {
    accessToken: string;
    googleId: string;
    userId: number;
  };
}

class GoogleConnectionService {
  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<GoogleConnection>> {
    return axios.get(URL, config);
  }

  static create(
    data: GoogleConnectionCreatePayload,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<GoogleConnection>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { GoogleConnectionService };
